import React, { useContext } from "react";

import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import NewAtendimentos from "../layout-new/pages/Atendimentos";
import { LayoutPreferenceContext } from "../context/LayoutPreference/LayoutPreferenceContext";

// Mesma ideia do LayoutSwitcher, mas pra uma rota especifica (/tickets)
// que tem versao propria no layout Novo - projeto 2026-10-21 (ver
// PROMPT.md em D:\voicechat\novo layout).
const TicketsPageSwitcher = () => {
	const { layout } = useContext(LayoutPreferenceContext);
	return layout === "new" ? <NewAtendimentos /> : <TicketResponsiveContainer />;
};

export default TicketsPageSwitcher;
